import React, {useState, useEffect} from 'react'
import Select from "react-select"
import axios from 'axios';
import cookie from 'react-cookies';
import {API_URL} from '../../../constants';

import $ from 'jquery';

function PrioridadSelect(props) {

  const [loading, setloading] = useState(true);
  const [options, setoptions] = useState([]);

  const getData = () => {
      let items = [
        {"label": 'Default ("Normal": Android, "High": iOS)', "value": 'D'},
        {"label": 'Normal', "value": 'N'},
        {"label": 'High', "value": 'H'},
      ]
      let newItems = [];

      if(items.length > 0){
        items.map((item) => {
          let itemData = {};
          itemData.value = item.value;
          itemData.label = item.label;

          newItems.push(itemData);
        });
      }
      setoptions(newItems);
  }

  useEffect(() => {
    if(loading){
      getData();
    }
  }, [])

  const changeSelect = (val) => {
    if(props.onChange){
      if(val !== null){
        props.onChange(val);
      }else{
        props.onChange("");
      }
    }
  }
  
  return (
    <Select 
        options={[...options]}
        onChange={(val) => changeSelect(val)}
        value={props.value}
        placeholder="Prioridad"
    />
  )
}

export default PrioridadSelect